var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.organizationName,
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: _vm.showModal,
        centered: ""
      },
      on: { hidden: _vm.reset },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.orgUpdateMemPending,
              expression: "orgUpdateMemPending"
            }
          ]
        },
        [
          _c("h2", { staticClass: "u-padding-bottom-20" }, [
            _vm._v("Updating, please wait ...")
          ]),
          _vm._v(" "),
          _c("pulse-loader", {
            attrs: {
              loading: _vm.orgUpdateMemPending,
              color: _vm.spinnerColor,
              size: _vm.spinnerSize
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.orgUpdateMemPending
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form",
                    [
                      _c("b", [_vm._v("Memberships: ")]),
                      _vm._v(" "),
                      _vm.selectedMemRec
                        ? _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.selectedMemRec.muser.fullName)
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "m-3",
                          attrs: {
                            id: "isOrgAdminOff",
                            name: "isOrgAdminOff",
                            "unchecked-value": "false",
                            switch: "",
                            incline: ""
                          },
                          model: {
                            value: _vm.selectedOrgAdmin,
                            callback: function($$v) {
                              _vm.selectedOrgAdmin = $$v
                            },
                            expression: "selectedOrgAdmin"
                          }
                        },
                        [
                          _vm._v(
                            "\n          Organization Administrator: Would you like for this user to be able to share, unshare and transfer records?\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "m-3",
                          attrs: {
                            id: "isOrgManagerOff",
                            name: "isOrgManagerOff",
                            "unchecked-value": "false",
                            switch: "",
                            incline: ""
                          },
                          model: {
                            value: _vm.selectedOrgManager,
                            callback: function($$v) {
                              _vm.selectedOrgManager = $$v
                            },
                            expression: "selectedOrgManager"
                          }
                        },
                        [
                          _vm._v(
                            "\n          Organization Manager: Would you like this user to be able to view all of the records for your organization?\n        "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "m-3",
                      attrs: {
                        id: "dwUser",
                        name: "dwUser",
                        "unchecked-value": false,
                        switch: "",
                        inline: ""
                      },
                      model: {
                        value: _vm.selectedDWUser,
                        callback: function($$v) {
                          _vm.selectedDWUser = $$v
                        },
                        expression: "selectedDWUser"
                      }
                    },
                    [
                      _vm._v(
                        "\n          Data Warehouse User: Would you like this user to be able to access the Lighthouse Data Warehouse application?\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "m-3",
                      attrs: {
                        id: "careCoordinator",
                        name: "careCoordinator",
                        "unchecked-value": false,
                        switch: "",
                        inline: ""
                      },
                      model: {
                        value: _vm.selectedCareCoordinator,
                        callback: function($$v) {
                          _vm.selectedCareCoordinator = $$v
                        },
                        expression: "selectedCareCoordinator"
                      }
                    },
                    [
                      _vm._v(
                        "\n        Care Coordinator: Would you like this user to access the Victim Identification tab designed for care coordinators?\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", [
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Created At: ")]),
                _vm._v("  " + _vm._s(_vm.getCreatedAt()) + "\n      "),
                _vm._.isObject(_vm.selectedMemRec.createdBy)
                  ? _c("div", [
                      _c("b", [_vm._v(" by: ")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._.get(
                              _vm.selectedMemRec,
                              "createdBy.emailAddress",
                              ""
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Last Updated: ")]),
                _vm._v("  " + _vm._s(_vm.getLastUpdateDate()) + "\n      "),
                _vm._.isObject(_vm.selectedMemRec.updatedBy)
                  ? _c("div", [
                      _c("b", [_vm._v(" by: ")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._.get(
                              _vm.selectedMemRec,
                              "updatedBy.emailAddress",
                              ""
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            fade: "",
            show:
              _vm.orgUpdateMemFailure ||
              _vm._.isObject(_vm.orgUpdateMemSuccess),
            variant: _vm.orgUpdateMemFailure ? "danger" : "success"
          }
        },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.apiResponseMessage()) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          !_vm.disableDelete
            ? _c(
                "b-button",
                {
                  staticClass: "float-left",
                  attrs: { type: "button", variant: "danger", size: "sm" },
                  on: { click: _vm.orgMemberHandlerDelete }
                },
                [_c("span", { staticClass: "button-text" }, [_vm._v("Delete")])]
              )
            : _c("span", { staticClass: "text-danger" }, [
                _vm._v(
                  " This is the primary organization for this user.  It cannot be removed.  "
                )
              ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "float-right",
              attrs: { type: "button", variant: "primary", size: "sm" },
              on: { click: _vm.orgMemberHandler }
            },
            [_c("span", { staticClass: "button-text" }, [_vm._v("Update")])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30fd0528", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fd0528","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/UpdateOrganizationsMemberModal.vue
// module id = 1868
// module chunks = 0